import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import i18n from 'i18next';
import styles from './SideMenuItem.module.scss';
import SideMenuItemProps from './SideMenuItemProps';
import { ReactComponent as Dashboard } from '../../assets/svg/menu/icon_dashboard.svg';
import { ReactComponent as Order } from '../../assets/svg/menu/icon_order.svg';
import { ReactComponent as Child } from '../../assets/svg/menu/icon_placeholder.svg';
import { ReactComponent as Report } from '../../assets/svg/menu/icon_reports.svg';
import {
    PATH_ORDERS,
    PATH_STOCK,
    PATH_ROOT,
    PATH_STOCK_PALLET,
} from '../../../constants/routerPaths';
import { NavigationElement } from '../../vms/NavigationElement';

export default function SideMenuItem(props: SideMenuItemProps) {
    const [expand, expandChilds] = React.useState(false);
    const { item, expandMenu } = props;
    const isActive = window.location.pathname === item.link;
    const isChildActive = item.childs.some(function (el: any) {
        return el.link === window.location.pathname;
    });

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;
        if (isActive) {
            timer = setTimeout(() => {
                expandChilds(true); //TODO FIX
            }, 100);
        }

        return () => {
            clearTimeout(timer);
        };
    });

    const getImage = (link: string) => {
        const miniStyle = expandMenu ? null : styles.miniLogo;
        const style = classNames(styles.logo, miniStyle);
        switch (link) {
            case PATH_ROOT: {
                return <Dashboard className={style} />;
            }
            case PATH_STOCK: {
                return <Report className={style} />;
            }
            case PATH_STOCK_PALLET: {
                return <Report className={style} />;
            }
            case PATH_ORDERS: {
                return <Order className={style} />;
            }
            default:
                return <Dashboard />;
        }
    };

    return (
        <>
            <Link
                to={item.link}
                target={item.target}
                className={classNames(
                    styles.link,
                    { [styles.linkActive]: isActive },
                    { [styles.noBorder]: !expandMenu },
                    { [styles.miniLinkActive]: !expandMenu && isActive }
                )}
            >
                {getImage(item.link)}
                {expandMenu && i18n.t(`menu.${props.item.name}`)}
            </Link>
            <div
                className={classNames(
                    styles.childItems,
                    { [styles.childItemsMini]: !expandMenu },
                    { [styles.childItemsActive]: expand || isChildActive }
                )}
            >
                {item.childs.map((child: NavigationElement, index: number) => (
                    <Link
                        target={child.target}
                        key={`${item.name}_${index}`}
                        to={child.link}
                        className={classNames(
                            styles.link,
                            styles.childLink,
                            { [styles.linkActive]: window.location.pathname === child.link },
                            { [styles.childLinkMini]: !expandMenu }
                        )}
                    >
                        <Child
                            className={classNames(styles.childLogo, {
                                [styles.childLogoActive]: window.location.pathname === child.link,
                            })}
                        />
                        {expandMenu && i18n.t(`menu.${child.name}`)}
                    </Link>
                ))}
            </div>
        </>
    );
}
